export default __webpack_public_path__ + "static/media/photo--sm--31.5fec3c7c.jpg";